import styled from '@emotion/styled';

import Card from 'components/global/Card';
import { HeaderContainerFormHeader } from 'components/global/styled/FormHeader.styled';

import { Breakpoints } from 'utils/const.styles';

export const Header = styled(HeaderContainerFormHeader)`
	@media ${Breakpoints.mobile} {
		padding: var(--padding-5) 4rem;
	}
`;

export const TitleContainer = styled.div`
	display: flex;
	align-items: center;
	width: 100%;
	gap: 2.6rem;
	border-bottom: 1px solid var(--border-color);
	padding: var(--padding-5);
	> div {
		display: flex;
		flex-direction: column;
		gap: 1rem;
		overflow: auto;
	}
`;

export const SalesChannelCard = styled(Card)`
	display: flex;
	flex-direction: column;
	gap: 1rem;
	padding: 0 !important;
	overflow: hidden !important;
`;

export const Content = styled.div`
	padding: var(--padding-5);
	overflow: auto;
`;
export const Gallery = styled.div`
	display: flex;
	flex-direction: column;
	gap: 2.6rem;
	position: relative;
	@media ${Breakpoints.mobile} {
		.swiper {
			width: 100%;
			.swiper-slide {
				text-align: center;
				background: #fff;
				display: flex;
				justify-content: center;
				align-items: center;
				max-height: 20rem;
			}

			.swiper-slide img {
				display: block;
				width: 100%;
				height: 100%;
				object-fit: fill;
			}

			.swiper-pagination {
				bottom: 0;
			}
		}
	}

	.swiper-container {
		width: 100%;
		max-height: 29.1rem;
		.swiper-wrapper {
			height: 100%;
		}

		.swiper-slide {
			width: 100%;
			height: 100%;
			border-radius: var(--small-border-radius);
			> img {
				width: 100%;
				height: 100%;
				object-fit: fill;
			}
		}

		.mobile-gallery {
			max-height: 100%;
		}
	}

	.swiper-thumbs-container {
		max-height: 11.3rem;
		margin-inline: unset !important;
		.swiper-wrapper {
			gap: 2.6rem;
		}
		.swiper-slide {
			border-radius: var(--small-border-radius);
			width: 33% !important;
			height: 100% !important;
			> img {
				width: 100% !important;
				height: 100% !important;
				object-fit: fill;
			}
		}
	}
`;
export const StoreInfo = styled.div`
	display: grid;
	grid-template-columns: ${({ hasImage }) => (hasImage ? 'repeat(2, minmax(0, 1fr))' : '2fr 1fr')};
	gap: ${({ hasImage }) => (hasImage ? '4.8rem' : '0rem')};
	overflow: auto;
	@media ${Breakpoints.tablet} {
		grid-template-columns: repeat(1, minmax(0, 1fr));
	}
`;

export const StoreInfoContent = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1rem;
`;

export const Highlights = styled.div`
	display: flex;
	flex-direction: column;
	flex-direction: column;
	gap: 2.6rem;
`;
export const HighlightsList = styled.div`
	display: grid;
	grid-template-columns: repeat(3, minmax(0, 1fr));
	gap: 2.6rem;

	@media ${Breakpoints.mobile} {
		grid-template-columns: repeat(2, minmax(0, 1fr));
	}
`;

export const StoreDescription = styled.div`
	line-height: 2.4rem;
	display: flex;
	flex-direction: column;
	gap: 1rem;
	flex: 1;
	margin-bottom: 2.4rem;
`;

export const HighlightContainer = styled.div`
	display: flex;
	gap: 1rem;
	flex: 1;
`;

export const HighlightContent = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1rem;
`;

export const ButtonWrapper = styled.div`
	display: flex;
	justify-content: center;
	margin-top: 1rem;
`;

export const InfoTabs = styled.div`
	.tabs {
		margin-bottom: 3.4rem;
		padding: 0;
	}
`;

export const Separator = styled.div`
	border-top: 1px solid var(--border-color);
	width: 100%;
	margin: var(--padding-5) 0;
`;

export const FaqContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 2.6rem;
`;
